import React from 'react'
import MenuSearchAdvancedSvg from 'images/modules/Manage/i-menu-search-advanced.svg?raw'

export { default as MenuSearchAdvancedUrl } from 'images/modules/Manage/i-menu-search-advanced.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: MenuSearchAdvancedSvg}} />
)
